export default __webpack_public_path__ + "static/media/environmental_standards.1fbc0b66.svg";